/* eslint-disable */
import React, { useEffect, useState } from 'react';
import FormControl from '@mui/material/FormControl';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { Button, Grid } from '@mui/material';
import LoginCard from 'ui-component/cards/LoginCard';
import { auth, encryptLocalStorageData } from 'helper/Utility';
import { useNavigate } from 'react-router';
import { INVOICE_APICALL } from 'helper/api/api';
import bluelogo from '../../assets/images/bluelogo.png';
import Alert from '@mui/material/Alert';
import { Secret, TOTP } from "otpauth";
import { QRCodeSVG } from "qrcode.react";

function Login() {
  const [Email, SetEmail] = useState('');
  const [Password, SetPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [msg, setMsg] = useState(null);
  const navigate = useNavigate();
  const authData = auth('admin');
  const [code, setCode] = useState('');
  const [stage, setStage] = useState('login');
  const [totp, setTotp] = useState(null);
  const [secret, setSecret] = useState(null);

  useEffect(() => {
    if (authData?.token) {
      if (authData?.role !== "admin") {
        navigate(`/`);
      } else {
        navigate(`/admin/dashboard`);
      }
    }
  }, []);


  const enable2FA = () => {
    if (!totp || !secret) {
      setMsg("TOTP not initialized");
      return;
    }
    const delta = totp.validate({ token: code, window: 2 });
    if (delta !== null) {
      localStorage.setItem("admin2faSecret", secret.base32);
      console.log("✅ Saved secret in LocalStorage:", secret.base32);
      setMsg(null);
      setStage("verify2fa"); // next time only verification
    } else {
      setMsg("Invalid 2FA code");
    }
  };

  const loginprocess = async () => {
    if (Email === '' || Password === '') {
      setMsg("Please Enter Email Or Password");
      return;
    }

    try {
      const res = await INVOICE_APICALL('admin/adminLogin', 'post', { email: Email, password: Password });
      if (res?.status) {
        const dataParam = {
          token: res?.token,
          firstName: res?.data?.firstName,
          lastName: res?.data?.lastName,
          email: res?.data?.email,
          id: res?.data?._id,
          role: res?.data?.role,
        };
        encryptLocalStorageData("admin-secret", dataParam, "DoNotTryToAccess");

        const savedSecret = localStorage.getItem("admin2faSecret");
        if (savedSecret) {
          // 🔑 Secret already exists → Only verify
          const rebuiltSecret = Secret.fromBase32(savedSecret);
          const rebuiltTotp = new TOTP({ issuer: "Invoice", label: "Admin", algorithm: "SHA1", digits: 6, period: 30, secret: rebuiltSecret });

          setSecret(rebuiltSecret);
          setTotp(rebuiltTotp);
          setStage("verify2fa");
        } else {
          // 🔑 No secret → First time setup
          const newSecret = new Secret();
          const newTotp = new TOTP({ issuer: "Invoice", label: "Admin",  algorithm: "SHA1", digits: 6, period: 30, secret: newSecret });

          setSecret(newSecret);
          setTotp(newTotp);
          setStage("setup2fa"); // Show QR
        }
      }
    } catch (error) {
      setMsg(error?.response?.data?.message);
    }
  };

  const verify2FA = () => {
    if (!totp) {
      setMsg("2FA not initialized");
      return;
    }
    const delta = totp.validate({ token: code, window: 2 });
    if (delta !== null) {
      setMsg(null);
      navigate('/admin/dashboard');
    } else {
      setMsg('Invalid 2FA code');
    }
  };

  const handlePasswordVisibilityToggle = () => {
    setShowPassword((prev) => !prev);
  };

  return (
    <Grid
      className="bg_image"
      container
      spacing={1}
      justifyContent={'center'}
      alignItems={'center'}
      height={'100vh'}
    >
      <Grid item md={4} justifyContent={'center'} alignItems={'center'}>
        <LoginCard className="outer-divv">
          <Grid container spacing={1} justifyContent={'center'} alignItems={'center'}>
            <Grid item md={10} justifyContent={'center'} alignItems={'center'}>
              <Grid container spacing={1} justifyContent={'center'} alignItems={'center'}>
                <Grid item sm={12} xs={12}>
                  <div className="app-logog text-center">
                    <img src={bluelogo} alt="" style={{ width: '120px', margin: 'auto' }} />
                  </div>
                </Grid>

                {stage === 'login' && (
                  <>
                    <Grid item sm={12} xs={12} className="mt-3">
                      <div className="section-tittle text-center">
                        <h1 variant="h1" className="tittle text-center" sx={{ pt: 0 }}>
                          <span className="shape"></span>Welcome!
                        </h1>
                      </div>
                    </Grid>

                    <Grid item sm={12} xs={12} className="mt-3 mb-3">
                      <label>
                        <strong>Email</strong>
                      </label>
                      <FormControl fullWidth>
                        <OutlinedInput
                          placeholder="Email"
                          onChange={(e) => SetEmail(e.target.value)}
                          className="form-inpitcustomfiled"
                        />
                      </FormControl>
                    </Grid>
                    <Grid item sm={12} xs={12}>
                      <label>
                        <strong>Password</strong>
                      </label>
                      <FormControl fullWidth>
                        <OutlinedInput
                          placeholder="Password"
                          type={showPassword ? 'text' : 'password'}
                          onChange={(e) => SetPassword(e.target.value)}
                          className="form-inpitcustomfiled"
                          endAdornment={
                            <InputAdornment position="end">
                              <IconButton onClick={handlePasswordVisibilityToggle} edge="end">
                                {showPassword ? <VisibilityOff /> : <Visibility />}
                              </IconButton>
                            </InputAdornment>
                          }
                        />
                      </FormControl>
                    </Grid>

                    <Grid item sm={12} xs={12} className="mt-2">
                      {msg && <Alert severity="error">{msg}</Alert>}
                    </Grid>
                    <Grid item xs={12}>
                      <Button
                        className="w-100 editprofile mt-sm-3 mt-3 mx-auto"
                        onClick={loginprocess}
                      >
                        Login
                      </Button>
                    </Grid>
                  </>
                )}

                {stage === 'setup2fa' && totp && (
                  <>
                    <Grid item xs={12} className="text-center">
                      <p>Scan this QR code in Google Authenticator:</p>
                      <QRCodeSVG value={totp.toString()} size={180} />
                    </Grid>
                    <Grid item xs={12}>
                      <label>Enter 6-digit code:</label>
                      <FormControl fullWidth>
                        <OutlinedInput
                          value={code}
                          placeholder="6-digit code"
                          inputProps={{ inputMode: 'numeric', pattern: '[0-9]*', maxLength: 6 }}
                          onChange={e => setCode(e.target.value.replace(/\D/g, '').slice(0, 6))}
                        />
                      </FormControl>
                    </Grid>
                    {msg && <Alert severity="error">{msg}</Alert>}
                    <Grid item xs={12}>
                      <Button className="w-100 mt-3" onClick={enable2FA}>Enable 2FA</Button>
                    </Grid>
                  </>
                )}


                {stage === 'verify2fa' && totp && (
                  <>
                    <Grid item sm={12} xs={12} className="mt-3 mb-3">
                      <label>Enter your 2FA code:</label>
                      <FormControl fullWidth>
                        <OutlinedInput
                          placeholder="6-digit code"
                          value={code}
                          inputProps={{ inputMode: 'numeric', pattern: '[0-9]*', maxLength: 6 }}
                          onChange={e => setCode(e.target.value.replace(/\D/g, '').slice(0, 6))}
                          className="form-inpitcustomfiled"
                        />
                      </FormControl>
                    </Grid>
                    {msg && <Grid item xs={12}><Alert severity="error">{msg}</Alert></Grid>}
                    <Grid item xs={12}>
                      <Button
                        className="w-50 editprofile mt-sm-3 mt-3 mx-auto"
                        onClick={verify2FA}
                      >
                        Login
                      </Button>
                    </Grid>
                  </>
                )}
              </Grid>
            </Grid>
          </Grid>
        </LoginCard>
      </Grid>
    </Grid>
  );
}

export default Login;
